import { MessageCircle } from "lucide-react";

const WA_PHONE = "919606094060"; // +91 96060 94060
const WA_MESSAGE = "Hi, I'd like to know more about your tours.";

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(WA_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" aria-hidden="true" />
      <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white shadow-xl shadow-black/20 transition-transform duration-200 group-hover:scale-105">
        <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" strokeWidth={2} />
      </span>
      <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#1F4D3A] text-[#F7F3EA] text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
    </a>
  );
}
